import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface BenefitSectionProps {
  number: number;
  title: string;
  headline: string;
  description: string;
  imageBadge: string;
  ctaText: string;
  imageUrl: string;
  isReversed?: boolean;
}
export function BenefitSection({
  number,
  title,
  headline,
  description,
  imageBadge,
  ctaText,
  imageUrl,
  isReversed = false
}: BenefitSectionProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 40
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6
  }} className={`flex flex-col md:flex-row gap-8 items-center py-12 md:py-16 border-b border-gray-100 last:border-0 ${isReversed ? 'md:flex-row-reverse' : ''}`} data-id="element-1">
      {/* Image Side */}
      <div className="w-full md:w-[60.72%] relative group" data-id="element-2">
        <div className="relative overflow-hidden rounded-2xl shadow-xl bg-gray-100" data-id="element-3">
          <img src={imageUrl} alt={title} className="w-full h-auto object-contain transition-transform duration-700 group-hover:scale-105" data-id="element-4" />
          {/* Purple Badge Overlay */}
          <div className="absolute bottom-4 left-4 bg-[#9AC1F0] text-white px-4 py-2 rounded-lg font-bold shadow-lg flex items-center gap-2 transform transition-transform group-hover:-translate-y-1" data-id="element-5">
            {imageBadge}
          </div>
        </div>
      </div>

      {/* Content Side */}
      <div className="w-full md:w-[39.28%] space-y-4" data-id="element-6">
        <div className="flex items-baseline gap-3" data-id="element-7">
          <span className="text-5xl font-black text-gray-200 leading-none select-none" data-id="element-8">
            {number}.
          </span>
          <h3 className="text-xl font-bold text-gray-900 uppercase tracking-tight" data-id="element-9">
            {title}
          </h3>
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight" data-id="element-10">
          {headline}
        </h2>

        <p className="text-lg text-gray-600 leading-relaxed" data-id="element-11">{description}</p>

        <a href="https://snugges.com/products/dogs-liquid-lick-bowl" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#9AC1F0] font-bold hover:text-[#7BA8D8] hover:underline group/link mt-2" data-id="element-12">
          👉 {ctaText}
          <ArrowRight className="w-4 h-4 transition-transform group-hover/link:translate-x-1" data-id="element-13" />
        </a>
      </div>
    </motion.div>;
}